const getType = (type: string) => {
  switch (type) {
    case 'required':
      return 'Required Field';
    case 'email':
      return ' Email format not valid';
    case 'onlyLetters':
      return 'Numbers are not valid';
    case 'maxLength':
      return 'Maximum length exceeded';
    case 'minLength':
      return 'Minimum length not reached 4 digits.';
    case 'cas':
      return 'CAS not valid please try again';
    case 'color':
      return 'Invalid Color format';
    case 'password_match':
      return 'Passwords do not match.';
    default:
      return type;
  }
};
interface Props {
  className?: string;
  type: string;
}
const ErrorMessage = ({ type, className }: Props) => {
  const classname = `text-danger ${className ?? ''}`;
  return (
    <small
      className={classname}
      // eslint-disable-next-line react/no-danger
      dangerouslySetInnerHTML={{ __html: getType(type) }}
    />
  );
};

export default ErrorMessage;
